import adminTabs from './AdminTabs'
import adminConfigManager from './AdminConfigManager'
export default {
  adminTabs,
  adminConfigManager
}
